export const QA_NAME_SEARCH_RESULTS_BUILDINGS_TABLE =
  'searchResultsBuildingsTable'

export const SEARCH_RESULTS_BUILDINGS_CONFIG_API =
  'idwell-api/api/v3/table/tables/buildings-search/'

export const SEARCH_RESULTS_BUILDINGS_LIST_API =
  'idwell-api/api/v3/construction/buildings/search/'
